import { useAdvancedModeStore } from "@vintecc/config-editor/stores";
import { connectionNavItems } from "@vintecc/config-editor/constants";
import { createFileRoute } from "@tanstack/react-router";
import { createConfigEditorCodeRoutes } from "@vintecc/config-editor/code-routes";

export const Route = createFileRoute("/sources/configurations/$id")({
  staticData: {
    title: "Configurations",
  },
  loader: async ({ location }) => {
    const isAdvancedMode = useAdvancedModeStore.getState().isAdvancedMode;

    const currentNavItem = connectionNavItems(location.pathname).find((item) => location.pathname.includes(`/${item.path}`));

    // If the user deep-links to an advanced tab while advanced mode is off, force-enable it.
    if (!isAdvancedMode && currentNavItem?.advanced) {
      useAdvancedModeStore.setState({ isAdvancedMode: true });
    }
  },
});

Route.addChildren(
  createConfigEditorCodeRoutes({
    basePath: "/sources/configurations/$id",
    getParentRoute: () => Route,
  }),
);
